export const TEXT_ASSIGN_MODE_TO_CONTACT_OWNER = 1
export const TEXT_ASSIGN_MODE_RANDOM_TO_AGENTS = 2
export const TEXT_ASSIGN_MODE_DO_NOTHING = 3
export const TEXT_ASSIGN_MODE_TO_LAST_CALLED_AGENT = 4
export const TEXT_ASSIGN_MODE_TO_LAST_CALLED_AGENT_REGARDLESS_OWNERSHIP = 5
